module.exports = __webpack_public_path__ + "resource/img/image051.86ebefcc.png";